<script lang="ts" setup>
import { ElFormItem, ElRadioGroup, ElRadio } from "element-plus";
import SelectEmployeeInput from "./SelectEmployeeInput.vue";
import { useI18n } from "vue-i18n";
import type { ExpandedUser } from "@/api/zoolander";

export interface Props {
  modelValue: boolean;
  hostName: string;
  locationId: string;
  label?: string;
}

defineProps<Props>();

const { t } = useI18n();

const emit = defineEmits<{
  (e: "update:model-value", value: boolean): void;
  (e: "selected-host", user: ExpandedUser): void;
  (e: "clear-host"): void;
}>();
</script>

<template>
  <el-form-item :label="label ?? t('visitors.preregistration.visitingToday')">
    <el-radio-group
      :model-value="modelValue"
      class="available-hosts"
      size="default"
      @update:model-value="
        (event) => emit('update:model-value', Boolean(event))
      "
    >
      <el-radio
        :label="false"
        class="available-hosts-radio"
        @click="emit('clear-host')"
      >
        {{ t("visitors.preregistration.noHost") }}
      </el-radio>
      <el-radio
        :label="true"
        class="available-hosts-radio"
      >
        {{ t("visitors.preregistration.visitingEmployee") }}
      </el-radio>
    </el-radio-group>
    <el-form-item
      v-if="modelValue"
      class="full-width"
      :label="t('visitors.preregistration.visitingHost')"
    >
      <SelectEmployeeInput
        :full-name="hostName"
        :location-id="locationId"
        @selected-user="(host) => emit('selected-host', host)"
        @clear="emit('clear-host')"
      />
    </el-form-item>
  </el-form-item>
</template>

<style lang="scss" scoped>
.full-width {
  width: 100%;
  margin-top: 15px;
}

.available-hosts {
  align-items: flex-start;
  flex-direction: column;
}

.available-hosts-radio {
  font-weight: var(--font-normal);
}
</style>
